// THE COMPACT DATE CONTROL (UI rebuild batch 2, Trades): the period chips' choices as one select beside the search box,
// and the two Dubai-day boxes on the line beneath it once "Dates…" is picked. The days a choice means come from
// PeriodChips' `periodDays` — the one place a period becomes desk days — so this control changes the look, not the rule.
import { PERIOD_CHIPS, type PeriodKey, type PeriodValue } from '../../PeriodChips';
import { fmtDay } from '../../../lib/format';

// Today reads as its Dubai date ("26 Oct 2026"), as Astra's date control does.
const choices = (): ReadonlyArray<readonly [PeriodKey, string]> => [
  ...PERIOD_CHIPS.filter(([k]) => k !== 'custom').map(([k, label]) => [k, k === 'today' ? fmtDay(new Date()) : label] as const),
  ['all', 'All time'],
  ['custom', 'Dates…'],
];

export function PeriodSelect({ value, onChange }: { value: PeriodValue; onChange: (next: PeriodValue) => void }) {
  return (
    <label className="min-w-0 flex-1 sm:flex-none">
      <span className="sr-only">Period</span>
      <select className="select w-full sm:w-auto" value={value.key} onChange={(e) => onChange({ ...value, key: e.target.value as PeriodKey })}>
        {choices().map(([k, label]) => <option key={k} value={k}>{label}</option>)}
      </select>
    </label>
  );
}

/** The two Dubai calendar days of "Dates…", both ends inclusive — drawn only while that choice is picked. */
export function PeriodDates({ value, onChange }: { value: PeriodValue; onChange: (next: PeriodValue) => void }) {
  if (value.key !== 'custom') return null;
  return (
    <div className="-mt-2 mb-4 grid grid-cols-2 gap-2 sm:flex sm:justify-end">
      <label className="min-w-0">
        <span className="mb-1 block text-label font-medium uppercase tracking-wider text-tg-hint">From</span>
        <input type="date" className="input w-full sm:w-44" value={value.from ?? ''} onChange={(e) => onChange({ ...value, key: 'custom', from: e.target.value })} />
      </label>
      <label className="min-w-0">
        <span className="mb-1 block text-label font-medium uppercase tracking-wider text-tg-hint">To</span>
        <input type="date" className="input w-full sm:w-44" value={value.to ?? ''} onChange={(e) => onChange({ ...value, key: 'custom', to: e.target.value })} />
      </label>
    </div>
  );
}
